import './index.scss';
import Configuration from './dispatcher/config/Configuration';
import Route from './components/router/Route';
import Router from './components/router/Router';
import { Ajax } from './dispatcher/ajax';
import Dispatcher from './dispatcher/Dispatcher';
import Component from './dispatcher/modules/component/Component';
import ActivityServiceInstance from './dispatcher/services/activity/ActivityService';

import WarningDialog from './dispatcher/modules/warning/WarningDialog';
import Dialog from './dispatcher/modules/dialog/Dialog';
import Widget from './dispatcher/modules/widget/Widget';
import DownloadWidget from './dispatcher/modules/widget/download/DownloadWidget';
import PureComponent from './dispatcher/modules/component/PureComponent';

import {
  ProgressBarHolder,
  ProgressBar,
  Indicator
} from './dispatcher/modules';
import { OperationType, Position } from './dispatcher/Types';
import DispatcherActions from './actions';
import DispatcherWindowManager from './utility/window/WindowManager';
import PopupWindowService from './dispatcher/services/window/PopupWindow';
import NavigationGrid from './components/grid/NavigationGrid';

import i18n from './locales/i18n';
import Translatable from './dispatcher/services/i18n/Translatable';
import CookieManagerService from './dispatcher/services/cookie/CookieManager';
import CookieUtil from './utility/CookieUtil';
import withFormControl from './components/hoc/form/withFormControl';
import { AuthService, AuthProvider } from './dispatcher/authentication';
import ThemeServiceInstance from './dispatcher/services/theme/ThemeService';
import { Service } from './dispatcher/services/Service';
import BaseGrid from './components/grid/BaseGrid';
import Dashboard from './components/dashboard/Dashboard';
import TermDashboard from './components/dashboard/TermDashboard';
import DashboardGrid from './components/dashboard/DashboardGrid';
import DashboardDrawer from './components/dashboard/DashboardDrawer';
import ESAPI from 'node-esapi';
import { CustomTagType } from './dispatcher/modules/customtag/Types';

Translatable.t = i18n.t.bind(i18n); // Initializing translatable

export * from './dispatcher/config/Constants';
export * from './dispatcher/Types';
export * from './components/hoc/form/Types';
export * from './components';
export * from './dispatcher/modules';
export * from './utility';
export * from './dispatcher/authentication/interfaces/AuthInterface';

Dispatcher.errorTrap.init();

Dispatcher.useServices({}, DispatcherActions);
DispatcherWindowManager.setWindowsZIndex();
DispatcherWindowManager.registerServiceToDispatcher();

const Esapi: ESAPI = ESAPI.encoder();
export {
  ActivityServiceInstance as ActivityService,
  Ajax,
  AuthProvider,
  AuthService,
  BaseGrid,
  Component,
  Configuration,
  CookieManagerService,
  CookieUtil,
  CustomTagType,
  Dashboard,
  TermDashboard,
  DashboardGrid,
  DashboardDrawer,
  Dialog,
  Dispatcher,
  DownloadWidget,
  Esapi,
  Indicator,
  NavigationGrid,
  OperationType,
  PopupWindowService,
  Position,
  ProgressBar,
  ProgressBarHolder,
  PureComponent,
  Route,
  Router,
  Service,
  ThemeServiceInstance as ThemeService,
  Translatable,
  WarningDialog,
  Widget,
  i18n,
  withFormControl
};
